import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DataState } from '@shared/enums/DataState';
import { AsyncData } from '@shared/interfaces/asyncData';
import { UserMainData } from '@shared/interfaces/user';

import { State } from './types';

const initialState: State = {
  userPersonalData: { data: null, state: DataState.Idle },
};

export const slice = createSlice({
  name: 'userPage',
  initialState,
  reducers: {
    setUserPersonalData(state, action: PayloadAction<AsyncData<UserMainData>>) {
      state.userPersonalData = action.payload;
    },
  },
});

export const { setUserPersonalData } = slice.actions;

export default slice.reducer;
